import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    ViewChild
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { ConstantesApp } from 'src/app/app.config/constantes-app';
import { Agente } from 'src/app/app.domain.models/agente';
import { Cliente } from 'src/app/app.domain.models/cliente';
import { DatosFirmaOperacion } from 'src/app/app.domain.models/datos-firma-operacion';
import { DatosToken } from 'src/app/app.domain.models/datos-token';
import { Poliza } from 'src/app/app.domain.models/poliza';
import { TokenOperacion } from 'src/app/app.domain.models/token-operacion';
import { EmailTemplateApiService } from 'src/app/app.domain.services/email-template.api.service';
import { EnvioEmailApiService } from 'src/app/app.domain.services/envio-email.api.service';
import { FileApiService } from 'src/app/app.domain.services/file.api.service';
import { TokenOperacionApiService } from 'src/app/app.domain.services/token-operacion.api.service';
import { FirmaWebsocketService } from 'src/app/app.services/firma-websocket.service';
import { Utilidades } from 'src/app/app.utilidades/utilidades';
import { ModalInformativoComponent } from 'src/app/core.components/modal-informativo/modal-informativo.component';
import { ArchivoCliente } from 'src/app/core.models/archivoCliente';
import { SesionService } from 'src/app/core.services/sesion.service';
import { ModalPoliticaPrivacidadComponent } from '../../modales/modal-politica-privacidad/modal-politica-privacidad.component';

@Component({
    selector: 'app-firma-cliente-comun',
    templateUrl: './firma-cliente-comun.component.html',
    styleUrls: ['./firma-cliente-comun.component.scss'],
})
export class FirmaClienteComunComponent implements AfterViewInit {

    readonly CONSTANTES = ConstantesApp;

    haComenzadoDibujo: boolean = false;
    @ViewChild('idCanva') idCanva: ElementRef | undefined;
    @ViewChild('inputFirmaContent') inputFirmaContent: ElementRef | undefined;
    xAnterior: number = 0;
    yAnterior: number = 0;
    xActual: number = 0;
    yActual: number = 0;
    contexto: any;
    color: string = 'black';
    grosor: number = 2;
    withCanva: number = 0;
    acepto: boolean = false;
    mensajeValidacionForm: string = '';
    mensajeErrorDniObligatorio!: string;
    firmaDibujada: boolean = false;

    archivoFirma!: ArchivoCliente;
    archivoDni!: ArchivoCliente;
    archivoDniReverso!: ArchivoCliente;

    nombreArchivoDni!: string;
    formDataDni!: FormData;
    nombreDocumento = '';

    nombreArchivoDniReverso!: string;
    formDataDniReverso!: FormData;
    nombreDocumentoReverso = '';

    cliente!: Cliente;
    agente!: Agente;
    titulo!: string;
    textoDescripcion!: string;
    mostrarUploadDni = false;
    dniObligatorio = false;

    imageDniBase64!: string;

    token!: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DatosToken,
        public dialogRef: MatDialogRef<FirmaClienteComunComponent>,
        public dialog: MatDialog,
        private cd: ChangeDetectorRef,
        private sesion: SesionService,
        private fileService: FileApiService,
        private translateService: TranslateService,
        private toastr: ToastrService,
        private firmaSocket: FirmaWebsocketService,
        private matDialog: MatDialog,
        private tokenOperacionService: TokenOperacionApiService,
        private emailTemplateService: EmailTemplateApiService,
        private envioEmailService: EnvioEmailApiService,
    ) {
        this.cliente = this.data.cliente ? this.data.cliente : this.sesion.getCliente();
        this.agente = this.data.agente;
        this.titulo = this.data.titulo ? this.data.titulo : '';
        this.textoDescripcion = this.data.textoDescripcion ? this.data.textoDescripcion : '';
        this.mostrarUploadDni = this.data.mostrarUploadDni;
        this.dniObligatorio = this.data.dniObligatorio;
        if (this.cliente) {
            this.nombreDocumento = Utilidades.getDateDDMMYYYY() + '_' + Utilidades.getNombreCompletoCliente(this.cliente).replace(' ', '_');
        }
    }

    touchStart(ev: TouchEvent) {
        const touch = ev.touches[0];
        this.xAnterior = this.xActual;
        this.yAnterior = this.yActual;
        this.xActual = this.obtenerXReal(touch.clientX);
        this.yActual = this.obtenerYReal(touch.clientY);
        this.contexto.beginPath();
        this.contexto.fillStyle = this.color;
        this.contexto.fillRect(
            this.xActual,
            this.yActual,
            this.grosor,
            this.grosor
        );
        this.contexto.closePath();
        this.haComenzadoDibujo = true;
        this.firmaDibujada = true;
    }

    touchMove(ev: TouchEvent) {
        ev.preventDefault();

        if (!this.haComenzadoDibujo) {
            return;
        }
        const touch = ev.touches[0];
        this.xAnterior = this.xActual;
        this.yAnterior = this.yActual;
        this.xActual = this.obtenerXReal(touch.clientX);
        this.yActual = this.obtenerYReal(touch.clientY);
        this.contexto.beginPath();
        this.contexto.moveTo(this.xAnterior, this.yAnterior);
        this.contexto.lineTo(this.xActual, this.yActual);
        this.contexto.strokeStyle = this.color;
        this.contexto.lineWidth = this.grosor;
        this.contexto.stroke();
        this.contexto.closePath();
        this.firmaDibujada = true;
    }

    touchEnd(ev: TouchEvent) {
        this.haComenzadoDibujo = false;
    }

    ngAfterViewInit() {
        this.contexto = this.idCanva?.nativeElement.getContext('2d');
        this.withCanva = 500;
        this.ajustarTamanioLienzo();
        this.cd.detectChanges();
        this.withCanva = 500;

        this.idCanva?.nativeElement.addEventListener(
            'touchstart',
            this.touchStart.bind(this),
            false
        );
        this.idCanva?.nativeElement.addEventListener(
            'touchmove',
            this.touchMove.bind(this),
            false
        );
        this.idCanva?.nativeElement.addEventListener(
            'touchend',
            this.touchEnd.bind(this),
            false
        );
    }

    ngOnDestroy() {
        this.idCanva?.nativeElement.removeEventListener(
            'touchstart',
            this.touchStart.bind(this),
            false
        );
        this.idCanva?.nativeElement.removeEventListener(
            'touchmove',
            this.touchMove.bind(this),
            false
        );
        this.idCanva?.nativeElement.removeEventListener(
            'touchend',
            this.touchEnd.bind(this),
            false
        );
    }

    ajustarTamanioLienzo() {
        const contenedor = this.inputFirmaContent?.nativeElement;
        this.idCanva!.nativeElement.width = contenedor.clientWidth;
        this.idCanva!.nativeElement.height = contenedor.clientHeight;
    }

    mouseUp(ev: any) {
        this.haComenzadoDibujo = false;
    }

    mouseOut(ev: any) {
        this.haComenzadoDibujo = false;
    }

    mouseDown(ev: any) {
        this.xAnterior = this.xActual;
        this.yAnterior = this.yActual;
        this.xActual = this.obtenerXReal(ev.clientX);
        this.yActual = this.obtenerYReal(ev.clientY);
        this.contexto.beginPath();
        this.contexto.fillStyle = this.color;
        this.contexto.fillRect(
            this.xActual,
            this.yActual,
            this.grosor,
            this.grosor
        );
        this.contexto.closePath();

        this.haComenzadoDibujo = true;
        this.firmaDibujada = true;
    }
    mouseMove(ev: any) {
        if (!this.haComenzadoDibujo) {
            return;
        }
        this.xAnterior = this.xActual;
        this.yAnterior = this.yActual;
        this.xActual = this.obtenerXReal(ev.clientX);
        this.yActual = this.obtenerYReal(ev.clientY);
        this.contexto.beginPath();
        this.contexto.moveTo(this.xAnterior, this.yAnterior);
        this.contexto.lineTo(this.xActual, this.yActual);
        this.contexto.strokeStyle = this.color;
        this.contexto.lineWidth = this.grosor;
        this.contexto.stroke();
        this.contexto.closePath();
        this.firmaDibujada = true;
    }

    obtenerXReal(clientX: number): number {
        const rect = this.idCanva!.nativeElement.getBoundingClientRect();
        const scaleX = this.idCanva!.nativeElement.width / rect.width;
        return (clientX - rect.left) * scaleX;
    }

    obtenerYReal(clientY: number): number {
        const rect = this.idCanva!.nativeElement.getBoundingClientRect();
        const scaleY = this.idCanva!.nativeElement.height / rect.height;
        return (clientY - rect.top) * scaleY;
    }

    limpiarFirma() {
        this.contexto.fillStyle = 'white';
        this.contexto.fillRect(
            0,
            0,
            this.idCanva?.nativeElement.width,
            this.idCanva?.nativeElement.height
        );
        this.firmaDibujada = false;
    }

    validarFirmaUsuario() {
        this.mensajeValidacionForm = '';
        this.mensajeErrorDniObligatorio = '';

        if (!this.firmaDibujada) {
            this.mensajeValidacionForm = this.translateService.instant('firma.necesaria') + '. ';
        }
        if (!this.acepto) {
            this.mensajeValidacionForm += this.translateService.instant('firma.necesario.aceptar.datos.biometricos') + '. ';
        }
        if (this.dniObligatorio && (!this.nombreArchivoDni || !this.nombreArchivoDniReverso)) {
            this.mensajeErrorDniObligatorio = this.translateService.instant('error.necesario.subir.dni');
        }
        return (this.mensajeValidacionForm.length === 0 && this.mensajeErrorDniObligatorio.length === 0);
    }

    regresar() {
        this.dialogRef.close(false);
    }

    public async procesarFirma() {
        if (this.cliente?.id && this.validarFirmaUsuario()) {
            // Convertir el canvas a blob
            let blob = await new Promise<Blob>((resolve) => {
                this.idCanva!.nativeElement.toBlob((result) => {
                    resolve(result);
                });
            });
            if (blob) {

                const formDataFirma = new FormData();
                formDataFirma.append('file', blob, this.nombreDocumento + '_' + 'FIRMA.png');
                const resArchivoFirma = await firstValueFrom(this.fileService.uploadFileCliente(formDataFirma, this.cliente.id));

                if (resArchivoFirma) {
                    this.archivoFirma = resArchivoFirma;
                    if (this.formDataDni) {
                        const resArchivoDni = await firstValueFrom(this.fileService.uploadFileCliente(this.formDataDni, this.cliente.id));
                        if (resArchivoDni) {
                            this.archivoDni = resArchivoDni;
                        } else {
                            console.error('Error al guardar archivo dni');
                        }
                    }
                    if (this.formDataDniReverso) {
                        const resArchivoDniReverso = await firstValueFrom(this.fileService.uploadFileCliente(this.formDataDniReverso, this.cliente.id));
                        if (resArchivoDniReverso) {
                            this.archivoDniReverso = resArchivoDniReverso;
                        } else {
                            console.error('Error al guardar archivo dni');
                        }
                    }
                } else {
                    console.error('Error al guardar archivo firma');
                }

                this.dialogRef.close({
                    archivoClienteFirma: this.archivoFirma,
                    archivoClienteDni: this.archivoDni,
                    archivoClienteDniReverso: this.archivoDniReverso,
                    imageDniBase64: this.imageDniBase64,
                });

            } else {
                console.error('No se pudo capturar la firma del canvas.');
            }
        }
    }

    abrirModalPoliticaPrivacidad() {
        const dialogRef = this.dialog.open(ModalPoliticaPrivacidadComponent, {
            panelClass: '',
            data: { component: ModalPoliticaPrivacidadComponent, mostrarBtnFooter: false },
        });

        dialogRef.afterClosed().subscribe((result) => { });
    }

    onFileChange(event: any) {
        if (event?.target?.files && event.target.files.length > 0) {
            const file: File = event.target.files[0];
            const maxFileSizeMB = 2;
            const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;
            const validExtensions = [
                'image/png',
                'image/jpeg',
                'image/jpg'
            ];

            if (file.size > maxFileSizeBytes) {
                const errorMessage = this.translateService.instant('contratar.archivo-demasiado-pesado', {
                    fileName: file.name,
                    maxFileSizeMB: maxFileSizeMB
                });

                this.toastr.error(errorMessage);
                event.target.value = '';
                return;
            }

            if (!validExtensions.includes(file.type)) {
                this.toastr.error(this.translateService.instant('contratar.archivo-no-admitido-imagen'));
                event.target.value = '';
                return;
            }

            if (file) {
                this.nombreArchivoDni = file.name;
                this.mensajeErrorDniObligatorio = '';
                this.formDataDni = new FormData();
                this.formDataDni.append('file', file);

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageDniBase64 = e.target!.result as string;
                }
                reader.readAsDataURL(file);
            }
        }
    }

    onFileChangeReverso(event: any) {
        if (event?.target?.files && event.target.files.length > 0) {
            const file: File = event.target.files[0];
            const maxFileSizeMB = 2;
            const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;
            const validExtensions = ['image/png', 'image/jpeg', 'image/jpg'];

            if (file.size > maxFileSizeBytes) {
                const errorMessage = this.translateService.instant('contratar.archivo-demasiado-pesado', {
                    fileName: file.name,
                    maxFileSizeMB: maxFileSizeMB
                });

                this.toastr.error(errorMessage);
                event.target.value = '';
                return;
            }

            if (!validExtensions.includes(file.type)) {
                this.toastr.error(this.translateService.instant('contratar.archivo-no-admitido-imagen'));
                event.target.value = '';
                return;
            }

            if (file) {
                this.nombreArchivoDniReverso = file.name;
                this.mensajeErrorDniObligatorio = '';
                this.formDataDniReverso = new FormData();
                this.formDataDniReverso.append('file', file);
            }
        }
    }

    // Firma remoto
    solicitarFirma() {
        this.insertarTokenOperacion(this.data.poliza).then((tokenOperacion: TokenOperacion) => {
            const datosFirmaOperacion: DatosFirmaOperacion = {
                _className: 'DatosFirmaOperacion',
                polizaId: tokenOperacion.polizaId!,
                clienteId: tokenOperacion.clienteId!,
                tipoOperacion: ConstantesApp.TIPO_OPERACION_FIRMA_REMOTO,
                tokenOperacionId: tokenOperacion.id!,

            }
            this.tokenOperacionService.generarTokenFirma(datosFirmaOperacion).then(
                (tokenFirma: string) => {
                    Utilidades.solicitarAccionRemotoCliente(this.emailTemplateService, this.envioEmailService, this.data.poliza, tokenFirma, 'FIRMA EN REMOTO');
                    this.toastr.info(this.translateService.instant('firma-cliente-comun.correo-enviado'));
                    this.token = tokenFirma;
                    this.firmaSocket.onMessage = data => this.pintaDesdeSocket(data);
                    this.firmaSocket.connect(this.token);
                }
            );

        });
    }

    private insertarTokenOperacion(poliza: Poliza): Promise<TokenOperacion> {
        const titulo = this.translateService.instant('firma.titulo.cambio-capital');

        const dataObject = {
            tipoOperacion: ConstantesApp.TIPO_OPERACION_FIRMA_REMOTO,
            titulo: titulo,
            cliente: poliza.cliente,
            poliza: poliza,

        }
        const tokenOperacion: TokenOperacion = {
            clienteId: this.data.poliza.cliente.id!,
            polizaId: this.data.poliza.id!,
            dataObject: JSON.stringify(dataObject),
            tipoOperacion: ConstantesApp.TIPO_OPERACION_FIRMA_REMOTO,
        }

        return this.tokenOperacionService.crear(tokenOperacion);
    }

    private abrirModalClienteConectado() {
        // Comprobar si existe el diálogo previamente
        const id = 'modal-mostrar-detalle';
        const dialog = this.matDialog.getDialogById(id);
        const title = "Información";
        const mensaje = "El cliente ha accedido al enlace de firma";

        if (!dialog) {
            const dialogConfig = new MatDialogConfig();
            // The user can't close the dialog by clicking outside its body
            dialogConfig.disableClose = true;
            dialogConfig.id = id;
            dialogConfig.data = { titulo: title, mensaje: mensaje };
            const modalDialog = this.matDialog.open(ModalInformativoComponent, dialogConfig);
            modalDialog.afterClosed().subscribe(() => {
                // que hacer al cerrar el modal, ej llamar a un callback
                //  this.modalCallback(result, data);
            });
        }
    }

    private abrirModalClienteDesconectado() {
        // Comprobar si existe el diálogo previamente
        const id = 'modal-mostrar-detalle';
        const dialog = this.matDialog.getDialogById(id);
        const title = "Información";
        const mensaje = "El cliente ha cerrado el enlace de firma";

        if (!dialog) {
            const dialogConfig = new MatDialogConfig();
            // The user can't close the dialog by clicking outside its body
            dialogConfig.disableClose = true;
            dialogConfig.id = id;
            dialogConfig.data = { titulo: title, mensaje: mensaje };
            const modalDialog = this.matDialog.open(ModalInformativoComponent, dialogConfig);
            modalDialog.afterClosed().subscribe(() => {
                // que hacer al cerrar el modal, ej llamar a un callback
                //  this.modalCallback(result, data);
                this.firmaSocket.disconnect();
            });
        }
    }
    
    private abrirModalClienteFirmado() {
        // Comprobar si existe el diálogo previamente
        const id = 'modal-mostrar-detalle';
        const dialog = this.matDialog.getDialogById(id);
        const title = "Información";
        const mensaje = "El cliente ha finalizado la firma";

        if (!dialog) {
            const dialogConfig = new MatDialogConfig();
            // The user can't close the dialog by clicking outside its body
            dialogConfig.disableClose = true;
            dialogConfig.id = id;
            dialogConfig.data = { titulo: title, mensaje: mensaje };
            const modalDialog = this.matDialog.open(ModalInformativoComponent, dialogConfig);
            modalDialog.afterClosed().subscribe(() => {
                // que hacer al cerrar el modal, ej llamar a un callback
                //  this.modalCallback(result, data);
                this.firmaSocket.disconnect();
            });
        }
    }

    private pintaDesdeSocket(data: any) {
        if (data.tipo === 'cliente_conectado') {
            this.abrirModalClienteConectado();
            return;
        }

        if (data.tipo === 'limpiar') {
            this.contexto.fillStyle = 'white';
            this.contexto.fillRect(
                0,
                0,
                this.idCanva?.nativeElement.width,
                this.idCanva?.nativeElement.height
            );
            return;
        }

        if (data.tipo === 'acepto') {
            this.acepto = data.valor;
            return;
        }

        if (data.tipo === 'cliente_desconectado') {
            this.abrirModalClienteDesconectado();
            this.token = '';
            return;
        }
        
        if (data.tipo === 'cliente_firmado') {
            this.abrirModalClienteFirmado();
            this.token = '';
            return;
        }

        this.contexto.beginPath();
        this.contexto.moveTo(data.xAnterior, data.yAnterior);
        this.contexto.lineTo(data.xActual, data.yActual);
        this.contexto.strokeStyle = data.color || 'black';
        this.contexto.lineWidth = data.grosor || 2;
        this.contexto.stroke();
        this.contexto.closePath();
        this.firmaDibujada = true;
    }

}
